import React from 'react';
import {defaultGetHeaders, pfetch} from "../helpers/wrappers";
import {notificarError} from "./Almacenes/AlmacenNotify";
import { IGV_INCLUIDO } from '../Global';
import "./styles/CunsultaPrecio.css";

export default class PriceConsulter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,
            prods: [],
            search: "",
            cleanSearch: true,
            cleaner: null,

            extImg: undefined,
            ruc: undefined
        }
        this.fetchProds = this.fetchProds.bind(this)
        this.onSubmitSearch = this.onSubmitSearch.bind(this)
    }

    componentDidMount() {
        this.fetchProds(this.state.search)
        this.fetchEmpresa()
    }

    fetchEmpresa() {
        pfetch({
            fetch: {
                url: `/api/guiaRemision/InfoEmpresa`,
                headers: defaultGetHeaders(),
            },
            before: () => this.setState({isLoading: true}),
            then: (data) => {
                const [{ Ruc}, extImg] = data;

                this.setState({
                    ruc: Ruc,
                    extImg: extImg
                });
            },
            finally: () => this.setState({isLoading: false}),
        })
    }

    fetchProds(search) {
        pfetch({
            fetch: {
                url: `/api/prices/?search=${search}`,
                headers: defaultGetHeaders(),
            },
            before: () => this.setState({isLoading: true}),
            then: (data) => this.setState({
                prods: data.map(d => {
                    return {
                        ...d,
                        precio: Boolean(d.afectacionFree) ? d.precio : d.precio * IGV_INCLUIDO
                    }
                })
            }),
            finally: () => this.setState({isLoading: false, search: this.state.cleanSearch ? '' : this.state.search}),
            error: () => notificarError("No se puedieron encontrar los productos")
        })
    }

    componentWillUnmount() {
        clearTimeout(this.state.cleaner)
    }

    onSubmitSearch(e) {
        e.preventDefault()
        this.fetchProds(this.state.search)
        this.setState((state) => {
            if (state.cleaner)
                clearTimeout(state.cleaner)
            return {
                cleaner: setTimeout(() => this.fetchProds(''), 5000)
            }
        })
    }

    render() {
        const {isLoading, prods, search, cleanSearch} = this.state
        return (
            <div className="mx-4">

                <div className="abed__container-consulta mt-3">
                    <div className="row height d-flex justify-content-center align-items-center">
                        {
                            (this.state.ruc && this.state.extImg) &&
                        
                                <div className="col-sm-auto">
                                    <img className="img-fluid" width="204" height="126"
                                        src={`${process.env.REACT_APP_FACT_BASE_URL}/datos/${this.state.ruc}/Img/logo_${this.state.ruc}.${this.state.extImg}`}
                                        alt="logo datos"/>
                                </div>
                        }
                        <div className="col-sm-auto">
                            <h1>Consultador de precios</h1>
                        </div>
                    </div>
                </div>

                <div className="abed__container-consulta mt-3">
                    <div className="row height d-flex justify-content-center align-items-center">
                        <form className="w-100" style={{display: "contents"}} onSubmit={this.onSubmitSearch}>
                            <div className="col-12 col-md-8 col-lg-6 mb-2 mb-md-0">
                                <input 
                                    className='abed__input-forml form-control'
                                    placeholder="Ingrese el nombre o código del producto y luego presione enter"
                                    type="text"
                                    value={search} 
                                    onChange={e => {
                                        const val = e.target.value
                                        this.setState({search: val})
                                    }}
                                />
                            </div>
                            <div className="col-12 col-md-auto">
                                <button type="submit" className="btn btn-outline-primary w-100 w-md-auto">
                                    Buscar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="abed__container-consulta mt-3">
                    <div className="row height d-flex justify-content-center align-items-center">
                        <div className="col-sm-auto">
                            Limpiar texto de búsqueda al momento de buscar
                            <input className="ml-2" type="checkbox" checked={cleanSearch} onChange={e => {
                                const checked = e.target.checked
                                this.setState({
                                    cleanSearch: checked
                                })
                            }}/>
                        </div>
                    </div>
                </div>

               <div className="abed__container-consulta mt-3">
    <div className="row">
        {isLoading ? (
            <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </div>
            </div>
        ) : (
            <div className="col-12">
                {prods.length === 1 ? (
                    <div className="row py-3 py-lg-5">
                        <div className="abed__mobile-card col-12 col-md-8 col-lg-6 mx-auto">
                            <h3 className="fw-light text-center text-muted mb-4">{prods[0].descripcion}</h3>
                            <h1 className="abed__product-price text-center p-4 " 
                                style={{ fontSize: "2rem"}}>
                                S./ {Number(prods[0].precio).toFixed(2)} 
                            </h1>
                        </div>
                    </div>
                ) : (
                    <>
                        {/* Vista desktop - Tabla */}
                        <div className="d-none d-md-block">
                            <div className="table-responsive abed__table">
                                <table className="table table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th className="col-8">Producto</th>
                                            <th className="col-4 text-end">Precio S./</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {prods.map((p, i) => (
                                            <tr key={i}>
                                                <td className="col-8">
                                                    <div className="fw-semibold text-dark">{p.descripcion}</div>
                                                </td>
                                                <td className="col-4 text-end fw-bold text-primary">
                                                    {Number(p.precio).toFixed(2)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Vista móvil - Cards */}
                        <div className="d-md-none">
                            {prods.map((p, i) => (
                                <div key={i} className="abed__mobile-card">
                                    <div className="abed__product-name">{p.descripcion}</div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span className="text-muted">Precio:</span>
                                        <span className="abed__product-price"> S./ {Number(p.precio).toFixed(2)}</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Estado vacío */}
                        {prods.length === 0 && (
                            <div className="abed__no-products">
                                <div className="mb-3">
                                    <i className="fas fa-search fa-3x"></i>
                                </div>
                                <h5 className="text-muted mb-2">No se encontraron productos</h5>
                                <p className="text-muted mb-0">Intenta con otros términos de búsqueda</p>
                            </div>
                        )}
                    </>
                )}
            </div>
        )}
    </div>
</div>
            </div>
        )
    }
}
